/**
 * 文件上传
 * Created by HeMengJiao on 2019/10/30.
 */
import axios from 'axios'
import AppConfig from '../appConfig'
import store from '../store/store'
import appConfig from '../appConfig'
import router from '../router'

//baseUrl
/*axios.defaults.baseURL = AppConfig.API.UPLOAD_URL;
//timeout
axios.defaults.timeout = 25000;
axios.defaults.headers['abgf'] = 'AUTH_TOKEN';*/

//获取Cookie
let getCookie = (name) => {
  let arr, reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
  if (arr = document.cookie.match(reg)) {
    return (arr[2])
  } else {
    return null
  }
}

//默认设置token
let token = store.state.token ? store.state.token : ''
if (!token) {
  token = getCookie('token')
  if (token) {
    token = unescape(token)
  }
}
axios.defaults.headers['token'] = token

//重置默认token
let resetToken = () => {
  let curToken = getCookie('token')
  if (curToken) {
    curToken = unescape(curToken)
  }
  if (token !== curToken) {
    token = curToken
  }
  axios.defaults.headers['token'] = token
}

export default {
  post(url, data) {
    // qs.stringify(data)
    resetToken()

    return axios({
      method: 'post',
      baseURL: AppConfig.API.BASE_URL_V3,
      url,
      data: data,
      timeout: 10000,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json; charset=UTF-8'
      }
    })
      .then((response) => {
        if (Number(response.data.code) === 20300) {
          // this.$message.info("登录已失效，返回登录页！")
          console.log(url)
          console.log(response)
          console.log("POST:登录已失效，返回登录页！")
          alert("登录已失效，返回登录页！")
          //跳转登录页
          window.location.href = '/login?redirect=' + router.history.current.path
        } else {
          //列表数据初始化
          if (Number(response.data.code) === 10000) {
            if (response.data.data !== null) {
              if (response.data.data.list === null) {
                response.data.data.list = []
              }
            } else {
              response.data.data = []
            }
          }

          return response
        }
      })
      .catch((err) => {
        return err
      })
  },

  get(url, params = {}) {
    resetToken()

    return axios({
      'method': 'get',
      baseURL: AppConfig.API.BASE_URL_V3,
      url,
      params, // get 请求时带的参数
      'timeout': 10000,
      'headers': {
        'X-Requested-With': 'XMLHttpRequest',
      }
    })
      .then((response) => {
        if (Number(response.data.code) === 20300) {
          // this.$message.info("登录已失效，返回登录页！")
          console.log(url)
          console.log(response)
          console.log("GET:登录已失效，返回登录页！")
          alert("登录已失效，返回登录页！")
          //跳转登录页
          window.location.href = '/login?redirect=' + router.history.current.path
        } else {
          //列表数据初始化
          if (Number(response.data.code) === 10000) {
            if (response.data.data !== null) {
              if (response.data.data.list === null) {
                response.data.data.list = []
              }
            } else {
              response.data.data = []
            }
          }
          return response
        }
      })
      .catch((err) => {
        return err
      })
  },

  downloadFile(url, params = {}, method = 'get') {
    resetToken()

    let httpData = {
      method: method,
      baseURL: AppConfig.API.BASE_URL_V3,
      url,
      timeout: 10000,
    }
    if (method === 'get') {
      httpData.params = params
      httpData.headers = {
        'X-Requested-With': 'XMLHttpRequest',
      }
    } else {
      httpData.data = params
      httpData.headers = {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json; charset=UTF-8'
      }
      httpData.responseType = 'blob'      //--设置请求数据格式
    }

    return axios(httpData)
      .then((response) => {
        if (Number(response.data.code) === 20300) {
          //跳转登录页
          window.location.href = appConfig.API.LOGIN_URL + '/login?redirect=' + appConfig.API.REDIRECT_URL + router.history.current.path
        } else {
          return response
        }
      })
      .catch((err) => {
        return err
      })
  },
}



// WEBPACK FOOTER //
// ./src/factory-api/https-v3.js